/* eslint-disable no-return-assign */
import dayjs from 'dayjs';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import _ from 'lodash';
import { useForm } from 'react-hook-form';
import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';

import {
  Box,
  Button,
  IconButton,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import {
  AddLinkRounded,
  ArrowBack,
  CheckCircleOutlineRounded,
  CloseRounded,
  EventRepeatRounded,
  ReportProblemRounded,
} from '@mui/icons-material';

import { toast } from 'react-toastify';
import {
  Container,
  Section,
  Input,
  VideoconferenceTitle,
  CheckButtons,
  ButtonExternal,
  ButtonZoom,
  ButtonTeams,
  DateConfigure,
  DateConfigureTitle,
  NumberOfMeeting,
  SuccessOAuth,
  TextZoom,
} from './styles';

import Jitsi from '../../../assets/JitsiLogo.png';

import {
  getMeetingByIdRequest,
  Guest,
  Meeting,
} from '../../../services/requests';

import { getCurrentTimezone } from '../../../utils/dateHelpers';

import useCompanyStore from '../../../store/companies';
import useAuthStore from '../../../store/auth';

import { ManualRecurrence } from '..';
import { ConfirmModal } from '../../../components/ConfirmModal';

interface CriarReuniaoProps {
  handleBack: () => void;
  handleMeeting: (formData: any) => void;
  listagemRecorrenciasManuais: ManualRecurrence[];
  setListagemRecorrenciasManuais: any;
  hasMeetingInvite: boolean;
  setHasMeetingInvite: (type: boolean) => void;
  teamsActived: any;
  setTeamsActived: (type: any) => void;
  zoomActived: any;
  setZoomActived: (type: any) => void;
  setLoadingZoom: (type: boolean) => void;
  jitsiActived: any;
  setJitsiActived: (type: any) => void;
  authorizationCode: string | null;
  setAuthorizationCode: (type: string | null) => void;
}

dayjs().format();

export interface GuestToSelect extends Guest {
  selected: boolean;
}

export function CriarReuniao({
  handleBack,
  handleMeeting,
  listagemRecorrenciasManuais,
  setListagemRecorrenciasManuais,
  hasMeetingInvite,
  setHasMeetingInvite,
  teamsActived,
  setTeamsActived,
  zoomActived,
  setZoomActived,
  setLoadingZoom,
  jitsiActived,
  setJitsiActived,
  authorizationCode,
  setAuthorizationCode,
}: CriarReuniaoProps) {
  const params = useParams();
  const selectedCompany = useCompanyStore(state => state.selectedCompany);
  const user = useAuthStore(state => state.user);

  const [meetingList, setMeetingList] = useState([
    { initial_date: '', initial_hour: '', duration: null },
  ]);
  const [meetingType, setMeetingType] = useState('LT3');
  const [showOnlineInputZoom, setShowOnlineInputZoom] = useState(false);
  const [showOnlineInputOthers, setShowOnlineInputOthers] = useState(false);
  const [showOnlineInputTeams, setShowOnlineInputTeams] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [dataInicial, setDataInicial] = useState('');
  const [duration, setDuration] = useState(0);
  const [time, setTime] = useState('');
  const [newMeetingId, setNewMeetingId] = useState('');
  const [externalActived, setExternalActived] = useState(true);
  const [openModalToAuthZoom, setOpenModalToAuthZoom] = useState(false);
  const [openModalToDisconnectZoom, setOpenModalToDisconnectZoom] =
    useState(false);
  const [isRecurrenceSorted, setIsRecurrenceSorted] = useState(false);

  const formValidation = useCallback((): any => {
    return Yup.object().shape({
      title: Yup.string().required('O título é obrigatório.'),
      start_at: Yup.string().required('A data inicial é obrigatória.'),
      time: Yup.string().required('O horário inicial é obrigatório.'),
      duration: Yup.number()
        .min(1, 'A duração não pode ser menor que 1')
        .moreThan(0, 'A duração deve ser maior que 0')
        .required('A duração é obrigatória.'),
      meeting_type: Yup.string().nullable(),
      link_address: Yup.string()
        .url('Digite um link de reunião válido')
        .nullable(),
      local_address: Yup.string().nullable(),
    });
  }, []);

  const {
    control,
    handleSubmit,
    setValue,
    formState: { isSubmitting },
  } = useForm({
    resolver: yupResolver(formValidation()),
  });

  const getMeetingById = useCallback(async () => {
    const meetingId = params?.id;
    setNewMeetingId(meetingId!);

    if (meetingId) {
      const response: Meeting = await getMeetingByIdRequest(
        meetingId as string,
        user?.id as string,
      );

      setValue('title', response.title);
      setValue(
        'start_at',
        dayjs(response.start_at)
          .tz(getCurrentTimezone(), true)
          .format('YYYY-MM-DDTHH:mm'),
      );
      setValue('duration', response.duration);
      setValue('link_address', response.link_address);
      setValue('local_address', response.local_address);

      if (response.link_address) {
        setShowOnlineInputTeams(true);
        setShowOnlineInputOthers(true);
        setShowOnlineInputZoom(true);
      }
    }
  }, [params?.id, setValue, user?.id]);

  useEffect(() => {
    if (selectedCompany && params?.id) {
      if (params?.id) {
        getMeetingById();
      }
    }
  }, [selectedCompany, params]);

  useEffect(() => {
    if (meetingType === 'LT1') {
      setShowOnlineInputZoom(true);
      setShowOnlineInputTeams(false);
      setShowOnlineInputOthers(false);
    } else if (meetingType === 'LT2') {
      setShowOnlineInputTeams(true);
      setShowOnlineInputZoom(false);
      setShowOnlineInputOthers(false);
    } else if (meetingType === 'LT3') {
      setShowOnlineInputTeams(false);
      setShowOnlineInputZoom(false);
      setShowOnlineInputOthers(true);
    } else {
      setShowOnlineInputTeams(false);
      setShowOnlineInputZoom(false);
      setShowOnlineInputOthers(false);
    }
  }, [meetingType, setValue]);

  useEffect(() => {
    if (params?.id) {
      setIsEdit(true);
    } else {
      setIsEdit(false);
    }
  }, [params]);

  // const handleRecurrenceClose = useCallback(() => {
  //   if (listagemRecorrenciasManuais?.length > 0) {
  //     setValue(
  //       'start_at',
  //       `${listagemRecorrenciasManuais[0]?.recurrence_initial_date}T${listagemRecorrenciasManuais[0]?.recurrence_initial_hour}`,
  //     );
  //     setValue(
  //       'duration',
  //       Number(listagemRecorrenciasManuais[0]?.recurrence_duration),
  //     );
  //     setDataInicial(
  //       `${listagemRecorrenciasManuais[0]?.recurrence_initial_date}T${listagemRecorrenciasManuais[0]?.recurrence_initial_hour}`,
  //     );
  //     setDuration(listagemRecorrenciasManuais[0]?.recurrence_duration);
  //   } else {
  //     setValue('start_at', '');
  //     setValue('duration', 0);
  //     setDataInicial('');
  //     setDuration(0);
  //   }
  //   setOpenDrawerRecurrence(false);
  // }, [listagemRecorrenciasManuais, setValue]);

  const handleAddRecurrenceManual = useCallback(() => {
    try {
      const allRecurrence = [...meetingList];

      const manualRecurrenceOrdered = _.orderBy(
        allRecurrence,
        'initial_date',
        'asc',
      );

      setListagemRecorrenciasManuais(manualRecurrenceOrdered);
    } catch (err) {
      console.log({ err });
    }
  }, [meetingList, setListagemRecorrenciasManuais]);

  // const getMessageOfRecurrenceTotal = useCallback(() => {
  //   const totalRecurernce = listagemRecorrenciasManuais.length;
  //   const lastMeetingOfRecurrence =
  //     listagemRecorrenciasManuais[totalRecurernce - 1];
  //   const finalDate = dayjs(
  //     lastMeetingOfRecurrence?.recurrence_initial_date,
  //   ).format('DD/MM/YYYY');

  //   if (totalRecurernce > 1) {
  //     return `${totalRecurernce} recorrências geradas com término em ${finalDate}`;
  //   }
  //   return `${totalRecurernce} recorrência gerada com término em ${finalDate}`;
  // }, [listagemRecorrenciasManuais]);

  const getLabelOfRecurrenceButton = useCallback(() => {
    const totalRecurernce = meetingList.length;

    if (totalRecurernce <= 1) {
      return `Incluir nova data (em caso de recorrência)`;
    }
    if (totalRecurernce === 2) {
      return `Incluir nova data`;
    }

    return `Incluir nova data`;
  }, [meetingList.length]);

  const handleSelectConference = useCallback(
    (conference: string) => {
      if (conference === 'external') {
        setExternalActived(prevState => !prevState);
        if (!externalActived) {
          setMeetingType('LT3');
        } else {
          setMeetingType('');
        }
        setZoomActived(false);
        setJitsiActived(false);
        setTeamsActived(false);
      }
      if (conference === 'zoom') {
        setZoomActived((prevState: any) => !prevState);
        setMeetingType('');
        setTeamsActived(false);
        setOpenModalToAuthZoom(false);
        setJitsiActived(false);
        setExternalActived(false);
      }
      if (conference === 'teams') {
        setTeamsActived((prevState: any) => !prevState);
        setMeetingType('');
        setZoomActived(false);
        setExternalActived(false);
        setJitsiActived(false);
      }
      if (conference === 'jitsi') {
        setJitsiActived((prevState: any) => !prevState);
        setMeetingType('');
        setTeamsActived(false);
        setZoomActived(false);
        setExternalActived(false);
      }
    },
    [externalActived, setTeamsActived, setZoomActived],
  );

  const handleAddMoreOneRecurrence = useCallback(() => {
    const newDate = dayjs(meetingList[meetingList.length - 1].initial_date)
      .add(1, 'month')
      .format('YYYY-MM-DD');

    setMeetingList([
      ...meetingList,
      {
        initial_date: newDate,
        initial_hour: meetingList[meetingList.length - 1].initial_hour,
        duration: meetingList[meetingList.length - 1].duration,
      },
    ]);
  }, [meetingList]);

  const handleRemoveRecurrence = useCallback(
    (index: number) => {
      const meetingsFiltered = meetingList?.filter((m, i) => i !== index);
      setMeetingList(meetingsFiltered);
      setListagemRecorrenciasManuais(meetingsFiltered);
    },
    [meetingList, setListagemRecorrenciasManuais],
  );

  const handleChangeDate = useCallback(
    (date: string, index: number) => {
      const listFiltered = meetingList?.map((m, i) => {
        if (i === index) {
          const meetingUpdate = {
            ...m,
            initial_date: date,
          };
          return meetingUpdate;
        }
        return m;
      });
      setMeetingList(listFiltered as any);
    },
    [meetingList],
  );

  const handleChangeHour = useCallback(
    (hour: string, index: number) => {
      const listFiltered = meetingList?.map((m, i) => {
        if (i === index) {
          const meetingUpdate = {
            ...m,
            initial_hour: hour,
          };
          return meetingUpdate;
        }
        return m;
      });
      setMeetingList(listFiltered as any);
    },
    [meetingList],
  );

  const handleChangeDuration = useCallback(
    (totalTime: number, index: number) => {
      const listFiltered = meetingList?.map((m, i) => {
        if (i === index) {
          const meetingUpdate = {
            ...m,
            duration: totalTime,
          };
          return meetingUpdate;
        }
        return m;
      });
      setMeetingList(listFiltered as any);
    },
    [meetingList],
  );

  const handleDisconnectZoom = useCallback(() => {
    setAuthorizationCode('');
    setOpenModalToDisconnectZoom(false);
    handleSelectConference('external');
  }, [handleSelectConference, setAuthorizationCode]);

  useEffect(() => {
    if (meetingList.length > 0) {
      handleAddRecurrenceManual();
    }
  }, [meetingList]);

  useEffect(() => {
    if (zoomActived) {
      setLoadingZoom(true);
      window.open(
        `https://zoom.us/oauth/authorize?response_type=code&client_id=YL1SUUvMRtqQEdOMG6CCw&redirect_uri=${process.env.REACT_APP_API_URL}/autenticacao-sucesso`,
      );
    }
  }, [zoomActived]);

  useEffect(() => {
    window.addEventListener(
      'message',
      event => {
        if (event.data.authorizationCode) {
          setLoadingZoom(false);
          toast.success('Autenticado com sucesso', { toastId: 1 });
          setAuthorizationCode(event.data.authorizationCode);
        }
      },
      false,
    );
  }, [setAuthorizationCode, setLoadingZoom]);

  function ChecksSortingDates(dates: string[]) {
    // eslint-disable-next-line no-plusplus
    for (let i = 1; i < dates.length; i++) {
      if (dates[i] < dates[i - 1]) {
        return true;
      }
    }
    return false;
  }

  useEffect(() => {
    if (meetingList) {
      const isSorted = ChecksSortingDates(meetingList.map(m => m.initial_date));

      if (isSorted) {
        setIsRecurrenceSorted(true);
      } else {
        setIsRecurrenceSorted(false);
      }
    }
  }, [listagemRecorrenciasManuais, meetingList]);

  return (
    <Container>
      <Typography className="title">Título e local da reunião:</Typography>
      <Section>
        <form onSubmit={handleSubmit(handleMeeting)} className="content">
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            flex="1 0 0"
            overflow="auto"
          >
            <Input
              name="title"
              control={control}
              required
              className="inputs"
              type="text"
              placeholder="Título da Reunião"
              InputLabelProps={{
                shrink: true,
              }}
            />
            {/* <div className="input-date">
              <div className="date">
                <TextField
                  label="Data de inicio"
                  // className="initial-input"
                  type="datetime-local"
                  value={dataInicial}
                  onChange={t => {
                    setDataInicial(t.target.value);
                    setValue('start_at', t.target.value);
                  }}
                  name="start_at"
                  // control={control}
                  fullWidth
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
              <div className="date">
                <TextField
                  // className="initial-input"
                  value={duration}
                  onChange={t => {
                    setDuration(t.target.value as any);
                    setValue('duration', Number(t.target.value));
                  }}
                  name="duration"
                  label="Duração em minutos"
                  fullWidth
                  type="number"
                  placeholder="Duração"
                  // control={control}
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </div> */}
            <Input
              className="inputs"
              type="text"
              placeholder="Endereço físico (opcional em caso de reunião presencial)"
              name="local_address"
              control={control}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <CheckButtons>
              <VideoconferenceTitle>Vídeoconferência:</VideoconferenceTitle>
              <Box display="flex" alignItems="center" gap="15px">
                {!authorizationCode && (
                  <ButtonExternal
                    isActived={externalActived}
                    // onClick={() => ({})}
                    onClick={() => handleSelectConference('external')}
                    // disabled
                  >
                    <AddLinkRounded
                      color="info"
                      sx={{ width: '29px', height: '29px' }}
                    />
                    Link externo
                  </ButtonExternal>
                )}
                {/* <ButtonZoom
                  isActived={zoomActived}
                  onClick={
                    authorizationCode
                      ? undefined
                      : () => setOpenModalToAuthZoom(true)
                  }
                  sx={{
                    cursor: authorizationCode ? 'not-allowed' : 'pointer',
                  }}
                >
                  <img src={Zoom} alt="Logo do Zoom" />
                  Zoom
                </ButtonZoom> */}
                <ButtonZoom
                  isActived={jitsiActived}
                  onClick={() => handleSelectConference('jitsi')}
                >
                  <img src={Jitsi} alt="Logo do Jitsi" />
                  Jitsi Meet
                </ButtonZoom>

                {jitsiActived && (
                  <SuccessOAuth sx={{ alignItems: 'flex-end' }}>
                    <CheckCircleOutlineRounded color="success" />
                    <TextZoom>
                      O link do Jitsi será gerado ao criar esta reunião.
                    </TextZoom>
                  </SuccessOAuth>
                )}

                {authorizationCode && (
                  <Tooltip title="Desfazer" placement="top">
                    <Button
                      variant="text"
                      color="error"
                      onClick={() => setOpenModalToDisconnectZoom(true)}
                      sx={{ minWidth: '0px', padding: '0' }}
                    >
                      <CloseRounded color="error" />
                    </Button>
                  </Tooltip>
                )}

                <ConfirmModal
                  open={openModalToAuthZoom}
                  onClose={() => setOpenModalToAuthZoom(false)}
                  onCancel={() => setOpenModalToAuthZoom(false)}
                  onConfirm={() => handleSelectConference('zoom')}
                  title="Zoom"
                  subtitle="O Zoom abrirá uma janela para conectar em sua conta."
                  text="Lembre-se: se o seu Zoom for gratuito o limite de duração da videochamada é de 40 minutos."
                  btnTextConfirm="PROSSEGUIR"
                  btnTextCancel="CANCELAR"
                  type="success"
                />
                <ConfirmModal
                  open={openModalToDisconnectZoom}
                  onClose={() => setOpenModalToDisconnectZoom(false)}
                  onCancel={() => setOpenModalToDisconnectZoom(false)}
                  onConfirm={handleDisconnectZoom}
                  title="Encerrar Conexão com o Zoom"
                  subtitle="Ao confirmar, sua autenticação será revogada e nenhum link do Zoom será gerado."
                  btnTextConfirm="PROSSEGUIR"
                  btnTextCancel="CANCELAR"
                  type="error"
                />
                {/* <ButtonTeams
                  isActived={teamsActived}
                  onClick={() => handleSelectConference('teams')}
                >
                  <img src={Teams} alt="Logo do Teams" />
                  Microsoft Teams
                </ButtonTeams> */}
              </Box>
              {authorizationCode && (
                <SuccessOAuth>
                  <CheckCircleOutlineRounded color="success" />
                  <TextZoom>
                    Autenticação concluída, o link do Zoom será gerado ao criar
                    esta reunião.
                  </TextZoom>
                </SuccessOAuth>
              )}
              {showOnlineInputZoom && (
                <Input
                  className="inputs"
                  type="text"
                  placeholder="ZOOM"
                  name="link_address"
                  control={control}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
              {showOnlineInputTeams && (
                <Input
                  className="inputs"
                  type="text"
                  placeholder="Ex: https://teams..."
                  name="link_address"
                  control={control}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
              {showOnlineInputOthers && (
                <Input
                  className="inputs"
                  type="text"
                  placeholder="Cole aqui o link da reunião"
                  name="link_address"
                  control={control}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            </CheckButtons>
            <DateConfigure>
              <DateConfigureTitle
                sx={{ marginTop: meetingType === '' ? '15px' : '0px' }}
              >
                Data, horário e duração da reunião:
                {isRecurrenceSorted ? (
                  <Tooltip title="Data de recorrência fora de ordenação">
                    <ReportProblemRounded
                      sx={{ width: '30px', height: '30px', color: '#f1c40f' }}
                    />
                  </Tooltip>
                ) : null}
              </DateConfigureTitle>
              {meetingList?.map((m, index) => (
                <Box display="flex" alignItems="center" width="100%">
                  <NumberOfMeeting>{`#${index + 1}`}</NumberOfMeeting>
                  <Box
                    display="flex"
                    alignItems="center"
                    gap="17px"
                    width="100%"
                  >
                    <TextField
                      placeholder="Data"
                      type="date"
                      value={m?.initial_date}
                      id={index.toString()}
                      error={
                        m?.initial_date.length > 0 &&
                        m?.initial_date < dayjs(new Date()).format('YYYY-MM-DD')
                      }
                      onChange={t => {
                        handleChangeDate(t.target.value, index);
                        setValue('start_at', t.target.value);
                      }}
                      key={index as any}
                      name="start_at"
                      fullWidth
                      required
                    />
                    <TextField
                      placeholder="Horário de início"
                      type="time"
                      value={m.initial_hour}
                      onChange={t => {
                        handleChangeHour(t.target.value, index);
                        setValue('time', t.target.value);
                      }}
                      error={
                        m.initial_hour.length > 0 &&
                        m.initial_date.concat('-', m.initial_hour as any) <
                          dayjs(new Date()).format('YYYY-MM-DD-HH:mm')
                      }
                      name="start_at"
                      fullWidth
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <TextField
                      value={m.duration}
                      onChange={t => {
                        handleChangeDuration(
                          parseInt(t.target.value, 10),
                          index,
                        );
                        setValue('duration', Number(t.target.value));
                      }}
                      name="duration"
                      fullWidth
                      error={
                        m.duration === null ? false : (m.duration as any) < 1
                      }
                      type="number"
                      inputProps={{ min: 1 }}
                      placeholder="Duração em minutos"
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />

                    <IconButton
                      sx={{ visibility: index > 0 ? 'none' : 'hidden' }}
                      onClick={() => handleRemoveRecurrence(index)}
                    >
                      <CloseRounded />
                    </IconButton>
                  </Box>
                </Box>
              ))}
            </DateConfigure>
            {/* {listagemRecorrenciasManuais?.length > 0 && (
              <RecurrenceCard>
                <RecurrenceCardText>
                  {getMessageOfRecurrenceTotal()}
                </RecurrenceCardText>
                <EventRepeatRounded />
              </RecurrenceCard>
            )} */}
            {!isEdit && (
              // <React.Fragment key="right">
              <Button
                onClick={handleAddMoreOneRecurrence}
                className="btn-repetition"
                variant="text"
              >
                <EventRepeatRounded sx={{ width: '22px', marginRight: 1 }} />
                {getLabelOfRecurrenceButton()}
              </Button>
            )}
            {/* <SwipeableDrawer
                  anchor="right"
                  open={openDrawerRecurrence}
                  onClose={() => handleRecurrenceClose()}
                  onOpen={() => setOpenDrawerRecurrence(true)}
                  ModalProps={{
                    keepMounted: true,
                  }}
                >
                  <Recorrencia
                    listagemRecorrenciasManuais={listagemRecorrenciasManuais}
                    setListagemRecorrenciasManuais={
                      setListagemRecorrenciasManuais
                    }
                    handleRecurrenceClose={handleRecurrenceClose}
                  />
                </SwipeableDrawer> */}
            {/* </React.Fragment> */}
          </Box>
          <Box
            display="flex"
            width="100%"
            justifyContent="space-between"
            marginTop="20px"
            flex="0 0 0"
          >
            {newMeetingId ? (
              ''
            ) : (
              <Button
                onClick={handleBack}
                sx={{
                  color: '#323232',
                  fontSize: '15px',
                  fontWeight: '500',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '15px',
                  backgroundColor: '#EEEEEE',
                  padding: '6px 22px 6px 16px',
                  height: '42px',
                }}
              >
                <ArrowBack /> Voltar
              </Button>
            )}
            <Box display="flex" alignItems="center" gap="15px">
              {!newMeetingId && (
                <Box display="flex" alignItems="center">
                  <Switch
                    defaultChecked
                    value={hasMeetingInvite}
                    onChange={prevState =>
                      setHasMeetingInvite(prevState.target.checked)
                    }
                  />
                  {hasMeetingInvite ? (
                    <Typography
                      sx={{
                        color: '#000',
                        fontSize: '14px',
                        fontFamily: 'Roboto',
                        fontWeight: '400',
                        lineHeight: '20px',
                        letterSpacing: '0.15px',
                      }}
                    >
                      Notificar participantes por e-mail
                    </Typography>
                  ) : (
                    <Box display="flex" flexDirection="column">
                      <Typography
                        sx={{
                          color: '#000',
                          fontSize: '14px',
                          fontFamily: 'Roboto',
                          fontWeight: '400',
                          lineHeight: '20px',
                          letterSpacing: '0.15px',
                        }}
                      >
                        Não notificar participantes
                      </Typography>
                      <Typography
                        sx={{
                          color: '#A3A3A3',
                          fontSize: '12px',
                          fontFamily: 'Roboto',
                          fontWeight: '400',
                          lineHeight: '20px',
                          letterSpacing: '0.15px',
                        }}
                      >
                        Não será criado um invite, você poderá alterar depois
                      </Typography>
                    </Box>
                  )}
                </Box>
              )}
              {isRecurrenceSorted ? (
                <Tooltip title="Data de recorrência fora de ordenação">
                  <Box>
                    <Button
                      variant="contained"
                      color="success"
                      disabled={isSubmitting || isRecurrenceSorted}
                      type="submit"
                      sx={{
                        color: '#ffffff',
                        fontSize: '15px',
                        fontWeight: '500',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '15px',
                        height: '42px',
                      }}
                    >
                      {newMeetingId ? 'Salvar alterações' : 'Criar reunião'}
                    </Button>
                  </Box>
                </Tooltip>
              ) : (
                <Button
                  variant="contained"
                  color="success"
                  disabled={isSubmitting}
                  type="submit"
                  sx={{
                    color: '#ffffff',
                    fontSize: '15px',
                    fontWeight: '500',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                    height: '42px',
                  }}
                >
                  {newMeetingId ? 'Salvar alterações' : 'Criar reunião'}
                </Button>
              )}
            </Box>
          </Box>
        </form>
      </Section>
    </Container>
  );
}
